import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'projects/fe-customer/src/environments/environment';
import { EncryptionService } from './encryption.service';
import { HttpService } from './httpService';


@Injectable({
  providedIn: 'root'
})
export class CustomerManageOrdersService {

  baseUrl: string = environment.baseURL;
  pagination = new BehaviorSubject({ search: '', page: 1, limit: 10, sortBy: '', sortKey: '', status: 1 });
  paginationSelling = new BehaviorSubject(
    { search: '', page: 1, limit: 10, sortBy: '', sortKey: '' }
  )
  token: any;
  companyId: any;
  httpOptions: { headers: any; };
  InternalCommentpagination = new BehaviorSubject(
    { search: '', page: 1, limit: 10, sortBy: '', sortKey: '' }
  )
  checkActiveTab = new BehaviorSubject({ isActiveTab: '' });

  constructor(private http: HttpService, private encryptionService: EncryptionService) {

  }

  getAllPaymentList(): Observable<any> {
    return this.http.get('v1/order-management/payment-terms/all-payment-terms-list');
  }

  getSellingList(customerId): Observable<any> {
    return this.http.post('v1/order-management/selling-catalog/get-selling-catalog-name-list', customerId);
  }

  getManageOrderList(data: any): Observable<any> {
    // convert limit string into number
    data.limit = Number(data.limit)
    return this.http.post('v1/order-management/order/order-list', data);
  }

  deleteOrder(data): Observable<any> {
    return this.http.post('v1/order-management/order/delete-order', data);
  }

  getCustomersList(): Observable<any> {
    return this.http.get('v1/order-management/order/customer-list');
  }

  addManageOrder(data: any): Observable<any> {
    return this.http.post('v1/order-management/order/add-order', data);
  }

  updateOrder(data: any): Observable<any> {
    return this.http.post('v1/order-management/order/edit-order', data);
  }

  getOrderDetails(id): Observable<any> {
    return this.http.get('v1/order-management/order/order-details-by-customer' + '/' + id);
  }


  getStatusCount(data): Observable<any> {
    return this.http.get('v1/order-management/order/get-order-count-by-customer/' + data);
  }

  changeStatus(data: any): Observable<any> {
    return this.http.post('v1/order-management/order/change-order-status', data);
  }

  getInternalCommentList(data: any): Observable<any> {
    // convert limit string into number
    data.limit = Number(data.limit)
    return this.http.post('v1/order-management/order/order-internal-comment-list', data);
  }

  deleteCommentList(data: any): Observable<any> {
    return this.http.post('v1/order-management/order/delete-order-internal-comment', data);
  }

  detailsCommentList(id: any): Observable<any> {
    return this.http.get('v1/order-management/order/order-internal-comment-details/' + id);
  }

  addOrderComment(data: any): Observable<any> {
    return this.http.post('v1/order-management/order/change-order-status', data);
  }

  updateOrderComment(data: any): Observable<any> {
    return this.http.post('v1/order-management/order/edit-order-internal-comment', data);
  }

  getSellingCatalogList(data: any): Observable<any> {
    // convert limit string into number
    data.limit = Number(data.limit)
    return this.http.post('v1/order-management/selling-catalog/get-selling-catalog-list-by-customer', data);
  }

  

  getSellingCatalogDetails(data: any): Observable<any> {
    return this.http.get('v1/order-management/selling-catalog/selling-catalog-details/' + data);
  }

  uploadFile(data: any): Observable<any> {
    return this.http.post('v1/data-storage/multi-upload', data);
  }

  getFileDetailsByIds(data: any): Observable<any> {
    return this.http.post('v1/data-storage/getFileDetailsByIds', data);
  }

  downloadFile(id: string): Observable<any> {
    let url = buildRequest('v2/data-storage/download/:id',
      {
        ':id': id
      });
    return this.http.get(url, { responseType: 'arraybuffer' });
  }


  downloadPdfFile(id: string) {
    let url = buildRequest('v2/data-storage/download-proposal/:id',
      {
        ':id': id
      });
    return this.http.get(url, { responseType: 'arraybuffer' });
  }


  getApprovedOrderList(data: any): Observable<any> {
    data.limit = Number(data.limit)
    if (!data.status) {
      delete data.status;
    }
    return this.http.post('v1/order-management/approved-order/order-list', data);
  }

  getApprovedOrderCount(data): Observable<any> {
    return this.http.post('v1/order-management/approved-order/get-order-count', data);
  }
  getApprovedOrderDetails(id): Observable<any> {
    return this.http.get('v1/order-management/approved-order/order-details' + '/' + id);
  }

  updateOrderStatus(id, data): Observable<any> {
    return this.http.put('v1/order-management/approved-order/change-order-status' + '/' + id, data);
  }

  updateOrderbyTask(id,data): Observable<any> {
    return this.http.put('v1/order-management/order/update-order-by-task' + '/' + id +'/'+ data.itemId,'');
  }
}

export let buildRequest = (string, params) =>
  string.split("/").map(el => {
    return params[el] ? params[el] : el
  }).join("/");